export default "__VITE_ASSET__BXfV5mlv__"